import Api from './Api';

const all = (payload) => {
    const path = '/site-owners';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const store = (payload) => {
    return Api.postRequest({
        endpoint: '/site-owner/store',
        data: payload
    });
};

const update = (payload) => {
    return Api.postRequest({
        endpoint: '/site-owner/update',
        method: 'PUT',
        data: payload
    });
};

const remove = (payload) => {
    return Api.deleteRequest({
        endpoint: `/site-owner/delete/${payload.id}`,
    });
};

const destroy = (payload) => {
    return Api.deleteRequest({
        endpoint: `/site-owner/destroy/${payload.id}`,
    });
};

export default {
    all,
    store,
    update,
    remove,
    destroy
};
